import React from "react";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import { Box } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHeaderComponent from "./TableHeader";
import TableBodyComponent from "./TableBody";

import { selectLocalization } from "@/store/store/selectors";

const TableComponent = (props) => {
  const { products, loading, stockTypes, purchaseStocks, onAddCost } = props;
  const localization = useSelector(selectLocalization);

  return (
    <Box paddingX={5} paddingTop={5}>
      <TableContainer
        sx={{
          maxHeight: "70vh",
        }}
      >
        <Table stickyHeader>
          <TableHeaderComponent products={products} stockTypes={stockTypes} />
          <TableBodyComponent
            loading={loading}
            localization={localization}
            purchaseStocks={purchaseStocks}
            products={products}
            stockTypes={stockTypes}
            onAddCost={onAddCost}
          />
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TableComponent;
